<template>
  <div>
    <Tabs value="name1">
      <TabPane label="油站抽佣" name="name1">
        <Form @keydown.native.enter.prevent="doSubmit" :label-width="140" :model="formData">
          <Card>
            <Row>
              <Col span="12">
                <FormItem label="类型：" prop="type">
                  <Select v-model="company_percentage.type">
                    <Option value="company">公司用户</Option>
                    <Option value="private">散户</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="站点类型：" prop="station_type">
                  <Select v-model="company_percentage.station_type">
                    <Option value="">所有站点</Option>
                    <Option value="2">小油</Option>
                    <Option value="3">撬装</Option>
                    <Option value="4">加油站</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                  <FormItem label="省市区：" prop="province">
                    <Select v-model="company_percentage.province" filterable style="width: 33%" placeholder="省" @on-change="changeProvince">
                      <Option value="">请选择</Option>
                      <Option v-for="(item,key) in provinces" :value="item">{{item}}</Option>
                    </Select>
                    <Select v-model="company_percentage.city" filterable style="width: 33%" placeholder="市" @on-change="changeCity">
                      <Option value="">请选择</Option>
                      <Option v-for="(item,key) in citys" :value="item">{{item}}</Option>
                    </Select>
                    <Select v-model="company_percentage.county" filterable style="width: 33%" placeholder="区">
                      <Option value="">请选择</Option>
                      <Option v-for="(item,key) in countys" :value="item">{{item}}</Option>
                    </Select>
                  </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="抽佣系数：" prop="percentage">
                  <Input v-model="company_percentage.percentage" placeholder="">
                    <span slot="append">元，公司用户按L抽成，散户按电话抽成</span>
                  </Input>
                </FormItem>
              </Col>

              <Form-item>
                <Button type="primary" @click="doSubmit">确定</Button>
              </Form-item>
            </Row>
          </Card>


        </Form>
      </TabPane>
      <TabPane label="新手指引" name="name2">
        <Editor ref="XSZY" v-model="contentXSZY" :value="contentXSZY"></Editor>
        <Button type="primary" @click="saveSXZYContent">保存</Button>
      </TabPane>
      <TabPane label="隐私协议" name="name3">
        <Editor ref="YSXY" v-model="contentYSXY" :value="contentYSXY"></Editor>
        <Button type="primary" @click="saveYSXYContent">保存</Button>
      </TabPane>
      <TabPane label="用户协议" name="yhxy">
        <Editor ref="YHXY" v-model="contentYHXY" :value="contentYHXY"></Editor>
        <Button type="primary" @click="saveYHXYContent">保存</Button>
      </TabPane>
      <TabPane label="电话抽佣" name="name4">
        <Card>
          <Form @keydown.native.enter.prevent="setConfig" :model="formData" :label-width="140">
            <Row>
              <Col span="12">
                <FormItem label="油站分佣系数：" prop="promote_commission_rate">
                  <Input v-model="formData.promote_commission_rate" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="尿素站分佣系数：" prop="promote_commission_niaosu">
                  <Input v-model="formData.promote_commission_niaosu" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="停车场分佣系数：" prop="promote_commission_park">
                  <Input v-model="formData.promote_commission_park" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="轮胎店分佣系数：" prop="promote_commission_tyre">
                  <Input v-model="formData.promote_commission_tyre" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="汽修店分佣系数：" prop="promote_commission_repair">
                  <Input v-model="formData.promote_commission_repair" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="篷布分佣系数：" prop="promote_commission_pengbu">
                  <Input v-model="formData.promote_commission_pengbu" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="地磅分佣系数：" prop="promote_commission_dibang">
                  <Input v-model="formData.promote_commission_dibang" placeholder="">
                    <span slot="append">元(每通电话为上级分佣多少)</span>
                  </Input>
                </FormItem>
              </Col>

              <Form-item>
                <Button type="primary" @click="setConfig">确定</Button>
              </Form-item>
            </Row>
          </Form>
        </Card>
      </TabPane>
      <TabPane label="客服电话" name="name5">
        <Card>
          <Form @keydown.native.enter.prevent="setCustomerServiceMobile" :model="formData" :label-width="140">
            <Row>
              <Col span="12">
                <FormItem label="客服电话：" prop="customerServiceMobile">
                  <Input v-model="customerServiceMobile" placeholder="">
                  </Input>
                </FormItem>
              </Col>

              <Form-item>
                <Button type="primary" @click="setCustomerServiceMobile">确定</Button>
              </Form-item>
            </Row>
          </Form>
        </Card>
      </TabPane>
    </Tabs>

  </div>
</template>

<script>
  import Editor from '@/components/editor'
  import config from '@/config/base-config'
  export default {
    name: "edit",
    components:{Editor},
    data(){
      return {
        formData:{
          /*buy_commission_rate:0,
          member_price:0,
          sale_commission_rate:0,
          member_discount:0,
          sy_percentage:0,
          ty_percentage:0,
          niaosu_station_percentage:0,
          niaosu_buy_commission:0,
          niaosu_sale_commission:0,*/
          promote_commission_rate:'',
          promote_commission_niaosu:'',
          promote_commission_park:'',
          promote_commission_tyre:'',
          promote_commission_repair:'',
          promote_commission_pengbu:'',
          promote_commission_dibang:'',
        },
        //企业抽成系数
        company_percentage:{
          station_type:'',
          province:'',
          city:'',
          county:'',
          percentage:'',
        },
        customerServiceMobile:'',
        contentXSZY:'',
        contentYSXY:'',
        contentYHXY:'',
        province_county_data:[],    //省市区数据
        provinces:[],
        citys:[],
        countys:[],
        apiPath:'https://oil.scsasy.com' + config.API_PATH,
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/config/getInfo',{});
        this.contentXSZY = res.data['xszy'];
        this.contentYSXY = res.data['ysxy'];
        this.contentYHXY = res.data['yhxy'];
        this.$refs.XSZY.setHtml(this.contentXSZY)
        this.$refs.YSXY.setHtml(this.contentYSXY)
        this.$refs.YHXY.setHtml(this.contentYHXY)
        this.formData.promote_commission_rate = res.data.promote_commission_rate
        this.formData.promote_commission_niaosu = res.data.promote_commission_niaosu
        this.formData.promote_commission_park = res.data.promote_commission_park
        this.formData.promote_commission_tyre = res.data.promote_commission_tyre
        this.formData.promote_commission_repair = res.data.promote_commission_repair
        this.formData.promote_commission_pengbu = res.data.promote_commission_pengbu
        this.formData.promote_commission_dibang = res.data.promote_commission_dibang
        this.customerServiceMobile = res.data.customer_service_mobile
      },
      init(){
        this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
          this.provinces = res.data.province_data
        })
      },
      async doSubmit(){
        let res = await this.$commonFun.postProxy('admin/company/setPercentage',this.company_percentage)
        this.$commonFun.dealApiResult(res)
        // this.getInfo()
      },
      async setConfig(){
        let res = await this.$commonFun.postProxy('admin/config/edit',this.formData)
        this.$commonFun.dealApiResult(res)
        // this.getInfo()
      },
      async setCustomerServiceMobile(){
        let res = await this.$commonFun.postProxy('admin/config/edit',{customer_service_mobile:this.customerServiceMobile})
        this.$commonFun.dealApiResult(res)
        // this.getInfo()
      },
      async saveSXZYContent(){
        let res = await this.$commonFun.postProxy('admin/config/editSXZY',{content:this.contentXSZY})
        this.$commonFun.dealApiResult(res)
      },
      async saveYSXYContent(){
        let res = await this.$commonFun.postProxy('admin/config/editYSXY',{content:this.contentYSXY})
        this.$commonFun.dealApiResult(res)
      },
      async saveYHXYContent(){
        let res = await this.$commonFun.postProxy('admin/config/editYHXY',{content:this.contentYHXY})
        this.$commonFun.dealApiResult(res)
      },
      uploadSuccess(res,file){
        this.$commonFun.dealApiResult(res,()=>{
          file.url = res.data.url;
          file.name = res.data.url;
          this.indexAd = res.data.url;
        })

      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      },
      uploadError(){
        this.$commonFun.errorTip('上传失败请重试')
      },
      formatError(){
        this.$commonFun.errorTip('图片格式不正确 jpg、jpeg、png')
      },
      exceededSize(){
        this.$commonFun.errorTip('图片大小不能超过2M')
      },
      seeImg(file){
        this.$Modal.info({
          // title: title,
          width:800,
          footerHide:true,
          content: `<img src="${file.url}" style="max-width: 500px;max-height: 500px">`
        });
      },

      changeProvince(province){
        this.citys = []
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach(val=>{
              this.citys.push(val.value)
            })
          }
        })
      },
      changeCity(city){
        this.countys=[]
        let province = this.company_percentage.province
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach((val)=>{
              if (val.value === city){
                val.children.forEach(val=>{
                  this.countys.push(val.value)
                })
              }
            })

          }
        })
      },
    },
    mounted() {
      this.getInfo()
      this.init()
    },
  }
</script>

<style scoped>

</style>
